<template>
    <div class="sustainability-page-results">
        <div class="container">
            <z-caption
                size="3xl"
                decor-left
                decor-right
                class="sustainability-page-results__title sustainability-page__title"
            >
                <span v-html="text.title" />
            </z-caption>
            <div class="sustainability-page-results__body">
                <z-tabs
                    kind="leaf"
                    :padding="false"
                    class="sustainability-page-results__tabs"
                >
                    <template v-slot:label>
                        <z-tabs-label id="results">
                            {{ text.tabs.results }}
                        </z-tabs-label>
                        <z-tabs-label id="goals">
                            {{ text.tabs.goals }}
                        </z-tabs-label>
                    </template>

                    <template v-slot:content>
                        <z-tabs-content id="results">
                            <div class="sustainability-page-results__content">
                                <div class="sustainability-page-results__image">
                                    <img
                                        src="/images/sustainability/new/results-img.webp"
                                        alt="results"
                                    >
                                </div>
                                <div class="sustainability-page-results__indicators">
                                    <accordion
                                        v-for="(result, index) in results"
                                        :key="index"
                                        :ref="'resultsAccordions'"
                                        :id="result.id"
                                        :title="result.title"
                                        :indicator="result.indicator"
                                        :image="result.image"
                                        :image-indicator="result.imageIndicator"
                                        @toggle="switchResultsAccordions"
                                        class="sustainability-page-results__indicator"
                                    >
                                        <p v-html="result.text" />
                                    </accordion>
                                </div>
                            </div>
                        </z-tabs-content>

                        <z-tabs-content id="goals">
                            <div class="sustainability-page-results__content">
                                <div class="sustainability-page-results__image">
                                    <img
                                        src="/images/sustainability/new/results-img.webp"
                                        alt="goals"
                                    >
                                </div>
                                <div class="sustainability-page-results__indicators">
                                    <accordion
                                        v-for="(goal, index) in goals"
                                        :key="index"
                                        :ref="'goalsAccordions'"
                                        :id="goal.id"
                                        :title="goal.title"
                                        :indicator="goal.indicator"
                                        :image="goal.image"
                                        :image-indicator="goal.imageIndicator"
                                        @toggle="switchGoalsAccordions"
                                        class="sustainability-page-results__indicator"
                                    >
                                        <p v-html="goal.text" />
                                    </accordion>
                                </div>
                            </div>
                        </z-tabs-content>
                    </template>
                </z-tabs>
            </div>
        </div>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'
import Accordion from './Accordion.vue'

export default {
    name: 'results-and-goals',
    components: { Accordion },
    data () {
        return {
            results: [
                {
                    id: 'energy',
                    title: localize({
                        ru: 'Электроэнергетика',
                        en: 'Electric Power Industry'
                    }),
                    indicator: '54%',
                    text: localize({
                        ru: 'Доля электроэнергии, полученной из&nbsp;ВИЭ по&nbsp;Группе по&nbsp;итогам 2024&nbsp;г.<br><br>12%&nbsp;— доля ВИЭ в&nbsp;общем потреблении электроэнергии и&nbsp;топлива по&nbsp;Группе по&nbsp;итогам 2024&nbsp;г.',
                        en: 'Share of&nbsp;electricity generated from renewable energy sources (RES) across the Group in&nbsp;2024<br><br>12%&nbsp;— share of&nbsp;renewable energy sources in&nbsp;the total consumption of&nbsp;electricity and fuel within the Group by&nbsp;the end of&nbsp;2024'
                    }),
                    image: '/images/sustainability/new/results-img-1.webp',
                    imageIndicator: '54%'
                },
                {
                    id: 'air',
                    title: localize({
                        ru: 'Воздух',
                        en: 'Air'
                    }),
                    indicator: localize({
                        ru: '8,6 млн тонн СО2e',
                        en: '8.6 mln tons of&nbsp;CO2e'
                    }),
                    text: localize({
                        ru: 'Фактические выбросы парниковых газов, охваты 1&nbsp;и&nbsp;2&nbsp;по&nbsp;итогам 2024&nbsp;г. —&nbsp;один из&nbsp;самых низких производственных уровней среди международных компаний горно-металлургической отрасли<br><br>5,5 млн т&nbsp;СО2 -экв. —&nbsp;выбросы парниковых газов, охват&nbsp;3 (downstream) по&nbsp;итогам 2024&nbsp;г.',
                        en: 'GHG emissions, scope 1&nbsp;and&nbsp;2, by&nbsp;the end of&nbsp;2024&nbsp;— one of&nbsp;the lowest production levels of&nbsp;CO2 (Scope 1&nbsp;&amp; 2) among international mining and metallurgical companies<br><br>5,5 mln t&nbsp;СО2e&nbsp;— GHG emissions, Scope&nbsp;3 (downstream) by&nbsp;the end of&nbsp;2024'
                    }),
                    image: '/images/sustainability/new/results-img-2.webp',
                    imageIndicator: localize({
                        ru: '8,6 млн',
                        en: '8.6 mln'
                    })
                },
                {
                    id: 'cost',
                    title: localize({
                        ru: 'Затраты на&nbsp;ЦУР ООН',
                        en: 'UN&nbsp;SDG Expenditures'
                    }),
                    indicator: localize({
                        ru: '374 млрд. ₽',
                        en: '374 billion RUB'
                    }),
                    text: localize({
                        ru: 'Объем затрат на&nbsp;проекты, связанные с&nbsp;ЦУР ООН, в&nbsp;2024 году (32% от&nbsp;выручки по&nbsp;раскрываемой консолидированной финансовой отчетности)',
                        en: 'Expenditures on&nbsp;UN&nbsp;SDGs related projects in&nbsp;2024 (32% of&nbsp;revenue under consolidated financial statement disclosures)'
                    }),
                    image: '/images/sustainability/new/results-img-3.webp',
                    imageIndicator: localize({
                        ru: '374 млрд',
                        en: '374 billion'
                    })
                },
                {
                    id: 'kpi',
                    title: localize({
                        ru: 'KPI в&nbsp;сфере ESG',
                        en: 'KPI in&nbsp;the ESG field'
                    }),
                    indicator: '40%',
                    text: localize({
                        ru: 'Вес командных KPI в&nbsp;сфере ESG',
                        en: 'Weight of&nbsp;team KPIs in&nbsp;the ESG field'
                    }),
                    image: '/images/sustainability/new/results-img-4.webp',
                    imageIndicator: '40%'
                }
            ],
            goals: [
                {
                    id: 'safety',
                    title: localize({
                        ru: 'Безопасность',
                        en: 'Safety'
                    }),
                    indicator: '0',
                    text: localize({
                        ru: 'Нулевая смертность на&nbsp;производстве&nbsp;&mdash; политика недопущения смертельных случаев на&nbsp;производстве',
                        en: 'Zero fatality rate in&nbsp;production&nbsp;&mdash; policy of&nbsp;preventing fatalities in&nbsp;the workplace'
                    }),
                    image: '/images/sustainability/new/goals-img-1.webp',
                    imageIndicator: '0'
                },
                {
                    id: 'air',
                    title: localize({
                        ru: 'Воздух',
                        en: 'Air'
                    }),
                    indicator: '-90%',
                    text: localize({
                        ru: 'Сокращение выбросов SO2&nbsp;на основных производственных площадках Норильского промышленного района к&nbsp;2031 году относительно базового 2015&nbsp;г.',
                        en: 'Reduction of&nbsp;SO2 emissions at&nbsp;key production sites of&nbsp;the Zapolyarny Division compared to&nbsp;the 2015 baseline'
                    }),
                    image: '/images/sustainability/new/goals-img-2.webp',
                    imageIndicator: '-90%'
                },
                {
                    id: 'ecology',
                    title: localize({
                        ru: 'Экология',
                        en: 'Ecology'
                    }),
                    indicator: '',
                    text: localize({
                        ru: 'Снижение негативного воздействия на&nbsp;окружающую среду и&nbsp;на&nbsp;биоразнообразие, местные сообщества в&nbsp;регионах присутствия и&nbsp;улучшение здравоохранения',
                        en: 'Reduction of&nbsp;negative impact on&nbsp;the environment and biodiversity, local communities in&nbsp;the areas of&nbsp;presence, and improvement of&nbsp;healthcare'
                    }),
                    image: '/images/sustainability/new/goals-img-3.webp',
                    imageIndicator: ''
                },
                {
                    id: 'kpi',
                    title: localize({
                        ru: 'KPI',
                        en: 'KPI'
                    }),
                    indicator: '5%',
                    text: localize({
                        ru: 'Долгосрочные КПЭ высшего руководства «Норникеля» в области устойчивого развития',
                        en: 'Weight of&nbsp;the key executives’ long-term KPIs in&nbsp;sustainable development'
                    }),
                    image: '/images/sustainability/new/goals-img-4.webp',
                    imageIndicator: '5%'
                }
            ],
            text: {
                title: localize({
                    ru: 'Результаты и&nbsp;цели',
                    en: 'Results and Goals'
                }),
                tabs: {
                    results: localize({
                        ru: 'Результаты',
                        en: 'Results'
                    }),
                    goals: localize({
                        ru: 'Ключевые цели',
                        en: 'Key Goals'
                    })
                }
            }
        }
    },
    methods: {
        switchResultsAccordions (currentId) {
            this.$refs.resultsAccordions.forEach(accordion => {
                if (accordion.id !== currentId) accordion.state = false
            })
        },
        switchGoalsAccordions (currentId) {
            this.$refs.goalsAccordions.forEach(accordion => {
                if (accordion.id !== currentId) accordion.state = false
            })
        }
    }
}
</script>

<style lang="scss">
.sustainability-page-results {
    padding-top: $token-spacers-l;
    padding-bottom: $token-spacers-3-xl;

    @include breakpoint(mobile) {
        padding-top: 0;
        padding-bottom: 0;
    }

    &__body {
        margin-top: $token-spacers-2-s;

        @include breakpoint(mobile) {
            margin-top: 0;
        }
    }

    &__content {
        display: flex;
        gap: $token-spacers-s;
    }

    &__image {
        flex: 1;
        max-width: 568px;
        border-radius: 0px 40px 0px 20px;
        overflow: hidden;

        @include breakpoint(tablet) {
            display: none;
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    &__indicators {
        min-width: 760px;
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: $token-spacers-2-xs;

        @include breakpoint(v-tablet) {
            min-width: 0;
        }

        @include breakpoint(mobile) {
            flex-direction: row;
            gap: $token-spacers-3-xs;
            padding: 0 16px;
            margin: 0 -16px;
            overflow-x: auto;
            scroll-snap-type: x mandatory;
            scroll-behavior: smooth;
        }
    }

    &__indicator {
        @include breakpoint(mobile) {
            min-width: 300px;
            // scroll-snap-align: start;
        }
    }
}
</style>
